document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.js-newsletter-popup');

  if (popup && localStorage.getItem('popup') !== 'true') {
    const showAfter = parseInt(popup.getAttribute('data-show-after'), 10) || 0;

    setTimeout(function () {
      popup.classList.add('display');
      setTimeout(() => popup.classList.add('show'), 50);
      document.body.style.overflow = 'hidden';
    }, showAfter);

    document.body.addEventListener('click', function (e) {
      if (e.target.closest('.js-close-newsletter-popup')) {
        popup.classList.add('closing');

        setTimeout(() => {
          popup.classList.remove('display', 'show', 'closing');
          document.body.style.overflow = 'visible';

          if (popup.getAttribute('data-show-only-once') === 'true') {
            localStorage.setItem('popup', 'true');
          }
        }, 300);

        e.preventDefault();
      }
    });
  }
});